import {
  GovernmentStrPage,
  validateGovernmentStrSearch,
} from "@/components/non_registrant/government-str-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/government/short-term-rentals")({
  validateSearch: validateGovernmentStrSearch,
  component: function ShortTermRentalsRoute() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <GovernmentStrPage
          search={search}
          onSearchChange={(next) => {
            void navigate({ search: next, replace: true });
          }}
        />
      </div>
    );
  },
});
